import { Icon } from '../lib/icons';

export function PricingCard({
  title,
  price,
  description
}: {
  title: string;
  price: string;
  description: string;
}) {
  return (
    <article className="rounded-lg border border-brand-border bg-white p-6 shadow-card">
      <div className="flex h-11 w-11 items-center justify-center rounded-md bg-brand-background text-brand-navy">
        <Icon name="check" className="h-5 w-5" />
      </div>
      <h3 className="mt-5 text-lg font-extrabold text-brand-dark">{title}</h3>
      <p className="mt-2 text-2xl font-extrabold text-brand-navy">{price}</p>
      <p className="mt-3 text-sm leading-7 text-brand-muted">{description}</p>
    </article>
  );
}
